import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  getFacturaOrdenes, 
  postFacturaOrdenes, 
  fetchMotivosSolicitudAnulacionApi 
} from '../../../api/axios';
import EstadoVentaAdm from "./EstadoVentaAdm";
import EstadoListItem from "./EstadoListItem";
import SolicitudAnulacion from "./SolicitudAnulacion";
import AnulacionReversion from "./AnulacionReversion";
import UploadFile from "../../General/UploadFile";
import ModalItem from '../../General/Modal';
import { toast } from 'react-toastify';
import { formatFile, base64ToArrayBuffer, saveByteArray } from "../../../utilities/formatFile";
import { filtroHoySplitted, filtroHoy } from "../../../utilities/fechasFiltro";
import { idEstadosOrden } from "../../../helper/ordenHelper";
const fechaHoySplitted = filtroHoySplitted();
const idEstados = idEstadosOrden;

class EstadosOrden extends Component {
  constructor(props) {
    super(props);
    this.state = {
      estados: [...this.props?.orden?.estado].reverse(),
      factura: "",
      notaDeCredito: "",
      filaFacturado: false,
      filaAnulado: false,
      btnFacturar: false,
      btnAnular: false,
      fechaFacturado: "",
      fechaAnulado: "",
      clickEliminarFactura: false,
      clickEliminarAnulado: false,
      facturaCargada: false,
      anuladaCargada: false,
      motivosSolicitudAnulacion: []
    }
  }

  componentDidMount() {
    this.props.orden.estado.map((item) => {
      if (item.idEstado == idEstados.facturado) {
        this.cargarFactura();
        this.setState({
          facturaCargada: true,
          filaFacturado: true,
          btnFacturar: true,
          fechaFacturado: item.fecha.slice(0, 10)
        })
      }

      if (item.idEstado == idEstados.anulado) {
        this.setState({
          anuladaCargada: true,
          filaAnulado: true,
          btnAnular: true,
          fechaAnulado: item.fecha.slice(0, 10)
        })
      }
    });

    if (this.props.userType.isSellerAdmin || this.props.userType.isSeller) {
      let request = fetchMotivosSolicitudAnulacionApi();
      request.then(res => {
        this.setState({ motivosSolicitudAnulacion: res.motivosSolicitudAnulacion });
      }).catch(err => {
        toast.error("No se encontraron motivos para solicitud de anulación");
      });
    }
  }

  cargarFactura = () => {
    let factura = getFacturaOrdenes(this.props.orden.idOrden, idEstados.facturado);

    factura.then(res => {
      this.setState({ factura: res.estado });
    }).catch(err => {
      toast.error("Descarga fallida");
    });
  }

  descargarFactura = (e) => {
    e.preventDefault();

    let factura = getFacturaOrdenes(this.props.orden.idOrden, e.target.id);
    factura.then(res => {
      let pdfData = base64ToArrayBuffer(res);
      saveByteArray("Factura", pdfData);
      toast.success("Descarga realizada");
    }).catch(err => {
      toast.error("Descarga fallida");
    });
  }

  descargarFacturaAdmin = (e) => {
    e.preventDefault();
    let pdfData = base64ToArrayBuffer(e.target.id);
    saveByteArray("Factura", pdfData);
    toast.success("Descarga realizada");
  }

  inputCreditoFile = async (dataPdf) => {
    let pdfFormatted = await formatFile(dataPdf, "pdf");
    await this.setState({ notaDeCredito: pdfFormatted });
  }

  inputFacturaFile = async (dataPdf) => {
    let one_week = this.checkDaysToUploadFactura();

    if (!one_week) {
      toast.warn("No puede subir / eliminar la factura pasados los 7 dias de facturado");
      return;
    }

    let pdfFormatted = await formatFile(dataPdf, "pdf");
    await this.setState({ factura: pdfFormatted });
  }

  checkDaysToUploadFactura = () => {
    let date = new Date();
    let today = new Date().getTime();
    let sevenDaysAgo = date.setDate(date.getDate() - 8);
    let fechaFacturado = new Date(this.state.fechaFacturado.replace(/-/g, '\/')).getTime();

    if (Number.isNaN(fechaFacturado)) {
      return true;
    }

    return sevenDaysAgo <= fechaFacturado && today >= fechaFacturado;
  }

  eliminarFilaFacturado = async () => {
    let estadosUpdate = this.state.estados.filter(estado => estado.updateFacturado !== true);

    await this.setState({
      clickEliminarFactura: this.state.facturaCargada,
      btnFacturar: false,
      filaFacturado: false,
      estados: estadosUpdate
    });
  }

  eliminarFilaAnulado = async () => {
    let estadosUpdate = this.state.estados.filter(estado => estado.updateAnulado !== true);

    await this.setState({
      clickEliminarAnulado: this.state.anuladaCargada,
      filaAnulado: false,
      btnAnular: false,
      estados: estadosUpdate
    });
  }

  agregarFacturado = () => {
    const newEstadoFacturado = {
      idEstado: idEstadosOrden.facturado,
      fecha: filtroHoy(),
      updateFacturado: true
    }

    let estadosUpdate = this.state.estados.concat([newEstadoFacturado]);

    this.setState({
      filaFacturado: true,
      btnFacturar: true,
      estados: estadosUpdate,
      updateFacturado: true
    });
  }

  agregarAnulado = () => {
    const newEstadoAnulado = {
      idEstado: idEstadosOrden.anulado,
      fecha: filtroHoy(),
      updateAnulado: true
    }

    let estadosUpdate = this.state.estados.concat([newEstadoAnulado]);

    this.setState({
      filaAnulado: true,
      btnAnular: true,
      estados: estadosUpdate
    });
  }

  postArchivoFactura = () => {
    let data = {
      "idSeller": this.props.orden.seller.codigo,
      "idOrden": this.props.orden.idOrden,
      "idEstado": idEstados.facturado,
      "comprobante": this.state.factura
    }

    const req = postFacturaOrdenes(data);
    req.then(res => {
      toast.success("Factura creada");
      this.goToOrdenes();
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("No pudo editarse");
    });
  }

  postArchivoNota = () => {
    if (this.state.clickEliminarFactura) {
      let data = {
        "idSeller": this.props.orden.seller.codigo,
        "idOrden": this.props.orden.idOrden,
        "idEstado": idEstados.pendiente,
        "comprobante": ""
      }

      const req = postFacturaOrdenes(data);
      req.then(res => {
        toast.success("Nota de credito creada");
      }).catch(err => {
        (err.response.data.errores)
          ? err.response.data.errores.forEach(error => toast.error(error))
          : toast.error("No pudo editarse");
      });
    }

    let data = {
      "idSeller": this.props.orden.seller.codigo,
      "idOrden": this.props.orden.idOrden,
      "idEstado": idEstados.anulado,
      "comprobante": this.state.notaDeCredito
    }

    const req = postFacturaOrdenes(data);
    req.then(res => {
      toast.success("Nota de credito creada");
      this.goToOrdenes();
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("No pudo editarse");
    });
  }

  eliminarFactura = () => {
    let data = {
      "idSeller": this.props.orden.seller.codigo,
      "idOrden": this.props.orden.idOrden,
      "idEstado": idEstados.pendiente,
      "comprobante": this.state.factura || ""
    }

    const req = postFacturaOrdenes(data);
    req.then(res => {
      toast.success("Factura eliminada");
      this.goToOrdenes();
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("No pudo editarse");
    });
  }

  eliminarAnulado = () => {
    if (this.state.facturaCargada && !this.state.clickEliminarFactura) {
      let data = {
        "idSeller": this.props.orden.seller.codigo,
        "idOrden": this.props.orden.idOrden,
        "idEstado": idEstados.facturado,
        "comprobante": this.state.factura
      }

      const req = postFacturaOrdenes(data);
      req.then(res => {
        toast.success("Nota de crédito eliminada");
        this.goToOrdenes();
      }).catch(err => {
        (err.response.data.errores)
          ? err.response.data.errores.forEach(error => toast.error(error))
          : toast.error("No pudo editarse");
      });
    }

    if (this.state.facturaCargada && this.state.clickEliminarFactura) {
      let data = {
        "idSeller": this.props.orden.seller.codigo,
        "idOrden": this.props.orden.idOrden,
        "idEstado": idEstados.pendiente,
        "comprobante": this.state.notaDeCredito
      }

      const req = postFacturaOrdenes(data);
      req.then(res => {
        toast.success("Nota de crédito eliminada");
      }).catch(err => {
        (err.response.data.errores)
          ? err.response.data.errores.forEach(error => toast.error(error))
          : toast.error("No pudo editarse");
      });
    }
  }

  estadoPendiente = () => {
    if (this.state.anuladaCargada && this.state.clickEliminarAnulado) {
      let data = {
        "idSeller": this.props.orden.seller.codigo,
        "idOrden": this.props.orden.idOrden,
        "idEstado": idEstados.pendiente,
        "comprobante": ""
      }

      const req = postFacturaOrdenes(data);
      req.then(res => {
        toast.success("Nota de crédito eliminada");
        this.goToOrdenes();
      }).catch(err => {
        (err.response.data.errores)
          ? err.response.data.errores.forEach(error => toast.error(error))
          : toast.error("No pudo editarse");
      });
    }
  }

  postArchivo = (e) => {
    e.preventDefault();
    this.estadoPendiente();

    const {
      factura,
      facturaCargada,
      filaAnulado,
      filaFacturado,
      clickEliminarFactura,
      clickEliminarAnulado,
      fechaFacturado
    } = this.state

    if (facturaCargada && filaAnulado) {
      this.postArchivoNota();
      return;
    }

    if (!filaFacturado && clickEliminarFactura) {
      this.eliminarFactura();
    }

    if (!filaAnulado && clickEliminarAnulado) {
      this.eliminarAnulado();
    }

    if (filaFacturado) {
      if (!factura) {
        toast.warn("El comprobante de factura es requerido");
        return;
      }
      this.postArchivoFactura();
    }

    if (filaAnulado) {
      if (!factura && fechaFacturado != "") {
        toast.warn("El comprobante de factura es requerido");
        return;
      }
      this.postArchivoNota();
    }
  }

  goToOrdenes = () => {
    this.props.history.push("/Ordenes");
  }


  render() {
    const { userType, orden } = this.props;
    const isCategoryOrAdmin = userType.isCategory || userType.isAdminMod;
    const isAdminOrSoloLectura = userType.isAdminMod || userType.isSoloLectura;
    const { fechaAnulado, fechaFacturado } = this.state;

    let mesAnulado = fechaAnulado?.slice(5, 7);
    let diaAnulado = fechaAnulado?.slice(8, 10);
    let mesFacturado = fechaFacturado?.slice(5, 7);
    let diaFacturado = fechaFacturado?.slice(8, 10);

    let btnEliminarAnulado = true;
    let btnEliminarFacturado = true;

    if (parseInt(mesAnulado) <= fechaHoySplitted.mes || parseInt(diaAnulado) <= fechaHoySplitted.dia) {
      btnEliminarAnulado = false;
    }

    if (parseInt(mesFacturado) < fechaHoySplitted.mes || parseInt(diaFacturado) < fechaHoySplitted.dia) {
      btnEliminarFacturado = false;
    }

    return (
      <div className="tab-pane p-10 active row" name="datos" id="home2" role="tabpanel">

        {isCategoryOrAdmin && this.props.orden.estado[0].idEstado === idEstados.solicitarAnulacion &&
          <AnulacionReversion
            idOrden={this.props.orden.idOrden}
            idSeller={this.props.idSeller}
            motivosRechazo={this.props.motivosRevision}
            motivoAnulacionSeller={this.props.orden.motivoAnulacion}
            goToOrdenes={this.goToOrdenes}
          />
        }

        {!isAdminOrSoloLectura &&
          <div className="col-12">
            <div className="row p-1 align-content-center">

              <div className="col-auto">
                {!this.state.btnFacturar &&
                  <button
                    className="btn m-r-10 btn-sm btn-grey mb-md-2"
                    type="button"
                    onClick={this.agregarFacturado}
                    disabled={this.state.anuladaCargada}
                  >
                    Cambiar a Facturado
                  </button>
                }
              </div>

              {userType.isCategory &&
                <div className="col-auto">
                  {!this.state.btnAnular &&
                    <button
                      className="btn m-r-10 btn-sm btn-grey mb-md-2"
                      type="button"
                      onClick={this.agregarAnulado}
                      disabled={this.state.btnAnular}
                    >
                      Anular orden
                    </button>
                  }
                </div>
              }

              <div className="col-auto">
                {!isCategoryOrAdmin && 
                  this.props.orden.estado[0].idEstado !== idEstadosOrden.anulado &&
                  <SolicitudAnulacion
                    idOrden={this.props.orden.idOrden}
                    idEstado={this.props.orden.estado[0].idEstado}
                    idSeller={this.props.idSeller}
                    motivoSolicitudOrden={this.props.orden.motivoAnulacion}
                    motivosAnulacion={this.state.motivosSolicitudAnulacion}
                    goToOrdenes={this.goToOrdenes}
                  />
                }
              </div>

            </div>
          </div>
        }

        <div className={`col-12 col-lg-${isCategoryOrAdmin ? "9" : "12"}`}>
          {this.state.estados.map((estado, index) => {
            return (
              <EstadoListItem key={index} idEstado={estado.idEstado} fecha={estado.fecha}>
                {/* // PENDIENTE */}
                {estado.idEstado === idEstados.pendiente && this.props.orden.motivoAnulacion?.id &&
                  <div className="form-group col-12 col-sm-4">
                    <label>Motivo de rechazo</label>
                    <select
                      className="form-control"
                      disabled={true}
                      defaultValue={this.props.orden.motivoAnulacion.id}
                    >
                      <option value={this.props.orden.motivoAnulacion.id}>
                        {this.props.orden.motivoAnulacion.detalle}
                      </option>
                    </select>
                  </div>
                }
                {/* // FACTURADA */}
                {estado.idEstado === idEstados.facturado &&
                  this.state.filaFacturado &&
                  this.state.btnFacturar &&
                  <>
                    {!isAdminOrSoloLectura &&
                      <div className="col-2 col-md-3">
                        <UploadFile
                          acceptType={".pdf"}
                          inputId={"inputFacturaFile"}
                          onFileLoaded={this.inputFacturaFile}
                        />
                      </div>
                    }

                    <div className="col-3">
                      <a href="#" onClick={this.descargarFactura} id={idEstados.facturado}>Descargar Factura</a>
                    </div>

                    {btnEliminarFacturado &&
                      <div className="col-2">
                        <ModalItem
                          text="¿Desea eliminar el estado Facturado?"
                          onDelete={this.eliminarFilaFacturado}
                          hidden={isAdminOrSoloLectura}
                          btnText="Eliminar"
                          btnStyle="btn m-r-10 btn-sm btn-grey"
                        />
                      </div>
                    }
                  </>
                }
                {/* // SOLICITUD ANULACION */}
                {estado.idEstado === idEstados.solicitarAnulacion &&
                  <div className="form-group col-12 col-sm-4">
                    <label>Motivo de anulación</label>
                    <select
                      className="form-control"
                      disabled={true}
                      defaultValue={this.props.orden?.motivoAnulacion?.id}
                    >
                      <option value={this.props.orden?.motivoAnulacion?.id}>
                        {this.props.orden.motivoAnulacion?.detalle}
                      </option>
                    </select>
                  </div>
                }
                {/* // ANULADA */}
                {estado.idEstado === idEstados.anulado &&
                  this.state.filaAnulado &&
                  this.state.btnAnular &&
                  <>
                    {!isAdminOrSoloLectura &&
                      <div className="col-2 col-md-3">
                        <UploadFile
                          acceptType={".pdf"}
                          inputId={"inputCreditoFile"}
                          onFileLoaded={this.inputCreditoFile}
                        />
                      </div>
                    }

                    <div className="col-3">
                      <a href="#" onClick={this.descargarFactura} id={idEstados.anulado}>
                        Descargar Nota de Crédito
                      </a>
                    </div>

                    {btnEliminarAnulado &&
                      <div className="col-2">
                        <ModalItem
                          text="¿Desea eliminar el estado Anulado?"
                          onDelete={this.eliminarFilaAnulado}
                          hidden={isAdminOrSoloLectura}
                          btnText="Eliminar"
                          btnStyle="btn m-r-10 btn-sm btn-grey"
                        />
                      </div>
                    }
                  </>
                }
              </EstadoListItem>
            )
          })
          }
        </div>

        {isCategoryOrAdmin &&
          <div className="col-12 col-lg-3 mt-4 mt-lg-0">
            <div className="row justify-content-center border-2 border-start">

              <div className="col-6">
                <EstadoVentaAdm
                  userId={this.props.userId}
                  idOrden={this.props.orden.idOrden}
                />
              </div>

              <div className="col-6 text-center" hidden={orden.pago.linkFactura ?? true}>
                <a
                  href="#"
                  onClick={this.descargarFacturaAdmin}
                  id={orden.pago.linkFactura}
                >
                  Descargar Factura Megatone
                </a>
              </div>

            </div>
          </div>
        }

        {!isAdminOrSoloLectura &&
          <form className="form-horizontal form-material mt-3">
            <div className="tab-content">
              <div className="row align-items-center justify-content-center">
                <button
                  className="col-auto btn btn-sm background-rojo-megatone waves-light"
                  onClick={this.postArchivo}
                >
                  Guardar
                </button>
              </div>
            </div>
          </form>
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  orden: state.ordenes.orden,
  userId: state.general.userId,
  userType: state.general.userType,
  idSeller: state.general.idSeller,
  motivosRevision: state.publicaciones.motivosRevision
});

export default connect(mapStateToProps)(EstadosOrden);